import { localizeWithPath } from '../../../../nls.js';
import { RawContextKey } from '../../../../platform/contextkey/common/contextkey.js';
const _moduleId = "vs/workbench/contrib/workspace/common/workspace";
const WorkspaceTrustContext = {
    IsEnabled: ( (new RawContextKey('isWorkspaceTrustEnabled', false, ( localizeWithPath(_moduleId, 0, "Whether the workspace trust feature is enabled."))))),
    IsTrusted: ( (new RawContextKey('isWorkspaceTrusted', false, ( localizeWithPath(
     _moduleId,
     1,
     "Whether the current workspace has been trusted by the user."
    )))))
};
const MANAGE_TRUST_COMMAND_ID = 'workbench.trust.manage';
export { MANAGE_TRUST_COMMAND_ID, WorkspaceTrustContext };
